// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CardHeader } from '@/components/card-header';
import { Divider, Paper, Stack } from '@mui/material';
import { ReactNode } from 'react';

interface HardfinTabCardWrapperProps {
  title: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  hideDivider?: boolean;
}

/**
 * Wrapper component that provides consistent card layout for detail tabs.
 * Follows the design pattern with Paper container, header, and content area.
 * Used across project, product, and other entity detail pages.
 */
export function HardfinTabCardWrapper(props: HardfinTabCardWrapperProps) {
  return (
    <Paper variant="outlined">
      <CardHeader
        title={props.title}
        sx={{
          '& .MuiTypography-root': {
            lineHeight: '2.5rem',
          },
          paddingX: 2,
          paddingY: 1,
        }}
      >
        {props.actions}
      </CardHeader>
      {!props.hideDivider && <Divider />}
      <Stack padding={2} paddingTop={0}>
        {props.children}
      </Stack>
    </Paper>
  );
}
